import {CxEvent} from '@spartacus/core';

export class DCPErrorEvent extends CxEvent {

  constructor(thrownError: any) {
    super();
    this.error = thrownError;
  }

  error: any;
}
